"use client";

import React, { useEffect, useRef, useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import Navbar from "../AdminDashboard/Navbar";
import SearchFilterMedication from "./SearchFilterMedication";
import LettersRecomdationPage from "./LettersRecomdationPage";
import { categories } from "@/utils/constant";
import { useTermListQuery } from "@/Redux/apis/product";
import Link from "next/link";
import { useSelector } from "react-redux";
import { useAddSearchHistoryMutation, useSearchHistoryQuery } from "@/Redux/apis/auth";
import { GoSearch } from "react-icons/go";
import SearchHistoryItem from "./SearchHistoryItem";
import { IoArrowForward } from "react-icons/io5";
import Loader from "@/Components/Loader/Loader";
import { useDebounce } from "@/utils/debouncing";
import { getSearchSuggestionIdentities, uniqueSearchSuggestions, withSearchSuggestionHistoryDisplay } from "@/utils/searchSuggestionIdentity";
import { getSearchSuggestionLabel } from "@/utils/searchSuggestionDisplay";
import { getKeywordForSelection, getSearchSelectionContext, logKeywordSearch } from "@/utils/logKeywordSearch";
const categories1 = [{
  name: "Drug Side Effects"
}, {
  name: "Drug Dosage"
}, {
  name: "Treatment Options"
}, {
  name: "Drugs by Class"
}, {
  name: "Drugs by Pharma Company"
}];
const Search = () => {
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [inputClicked, setInputClicked] = useState(false);
  const [showSearchComponent, setShowSearchComponent] = useState(true);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const filterDropdownRef = useRef(null);
  const users = useSelector(state => state?.userData?.userData?.user);
  const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const handelViewProductsList = () => {
    // setInputClicked(true);
    // setShowSearchComponent(false);
    // setIsLetterClicked(false);
  };
  const handleSearchChange = e => {
    setSelectedLetter("");
    setSearchQuery(e.target.value);
    if (e.target.value === "") {
      setTermList([]);
    }
  };
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !inputRef.current.contains(event.target)) {
        setTermList([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [isLetterClicked, setIsLetterClicked] = useState(false);
  const handleLetterClick = letter => {
    setSelectedLetter(letter);
    setIsLetterClicked(true);
    setInputClicked(false);
    setShowSearchComponent(false);
  };
  const handelBacktoSearch = () => {
    setShowSearchComponent(true);
    setIsLetterClicked(false);
  };
  const [isSuggestionOpen, setIsSuggestionOpen] = useState(false);
  useEffect(() => {
    function handleClickOutside_0(event_0) {
      if (dropdownRef.current && !dropdownRef.current.contains(event_0.target) && !inputRef.current.contains(event_0.target)) {
        setIsSuggestionOpen(false);
        setTermList([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside_0);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside_0);
    };
  }, []);
  const [page, setPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [manualLoader, setManualLoader] = useState(false);
  const [termList, setTermList] = useState([]);
  const {
    data: termData,
    error: termError,
    isLoading: isTermLoading,
    status: termStatus
  } = useTermListQuery({
    search: debouncedSearchQuery || selectedLetter,
    page,
    type: selectedLetter ? "letter" : "all"
  }, {
    refetchOnMountOrArgChange: true,
    skip: debouncedSearchQuery?.trim()?.length < 0
  });
  function isExactMatch() {
    return termList.some(item => item.name.toLowerCase() === searchQuery.toLowerCase());
  }
  const searchHistoryAPI = useSearchHistoryQuery(users?._id, {
    skip: !users?._id
  });
  const [searchHistoryLoading, setSearchHistoryLoading] = useState(true);
  const [searchHistory, setSearchHistory] = useState([]);
  useEffect(() => {
    if (searchHistoryAPI?.isLoading || searchHistoryAPI?.isFetching) {
      setSearchHistoryLoading(true);
    } else if (!searchHistoryAPI.isLoading && searchHistoryAPI.isSuccess) {
      setSearchHistoryLoading(false);
      setSearchHistory(searchHistoryAPI?.data?.history);
    } else if (searchHistoryAPI?.isError) {
      setSearchHistoryLoading(false);
    }
  }, [searchHistoryAPI]);
  useEffect(() => {
    if (termData && !isTermLoading) {
      setManualLoader(false);
      if (termData?.productslist?.length < 10) {
        setHasMoreData(false);
      } else {
        setHasMoreData(true);
      }
      setTermList(termData.productslist || []);
    }
  }, [termData]);
  const router = useRouter();
  const pathname = usePathname();
  const generateEncodedUrl = params => {
    const queryString = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
    return queryString;
  };
  const [addSearchHistory, searchHistoryAddResponse] = useAddSearchHistoryMutation();
  const handleClick = async (data, from) => {
    if (from !== "history") {
      void logKeywordSearch(getKeywordForSelection(searchQuery, data), getSearchSelectionContext(data, "search"));
    }
    let type = data.type;
    // return

    if (type === "drug" || type == "biologic" || type == "vaccine" || type == "otc" || type == "device") {
      if (from === "history") {
        router.push(`/products/${type}/${data.clickedProduct.productAlias}`);
      } else {
        router.push(`/products/${type}/${data.productAlias}`);
      }
      return;
    }
    // Pipeline (pre-approval) drugs live at /pipeline/:slug, not under
    // /products/:type/:alias. Same routing branch as the homepage
    // Find Products search — without this, clicking a pipeline
    // suggestion fell through to the search-results listing (the
    // skeleton screen the user reported) instead of opening the
    // detail page. Opening the detail page is also what fires the
    // PipelineViewTracker that drives the trending leaderboard, so
    // routing here matters for both UX and analytics.
    if (type === "pipeline") {
      const slug = from === "history" ? data.clickedProduct?.productAlias || data.clickedProduct?.slug : data.productAlias || data.slug;
      if (slug) {
        router.push(`/pipeline/${slug}`);
        return;
      }
    }
    const isDiagnosis = type === "Diseases" || type === "diseases" || type === "Disease" || type === "Psychiatry and Psychology";
    if (from !== "history" && isDiagnosis) {
      await addSearchHistory({
        type,
        searchQuery,
        result: data
      }).unwrap();
    }
    let url = "";
    if (from === "history") {
      url = `/search/query?${generateEncodedUrl({
        search: data.type === "manufacturer" ? data.clickedProduct.productName : data.id || data.clickedProduct.productId,
        searchQuery: data.type === "manufacturer" ? data.clickedProduct.productName : data?.clickedProduct?.productName ? data?.clickedProduct?.productName : data?.clickedProduct?.genericName,
        term: data.type === "Diseases" || data.type === "Psychiatry and Psychology" ? data?.clickedProduct?.productName : data.type === "manufacturer" ? data?.clickedProduct?.productName : data?.clickedProduct?.productName ? data?.clickedProduct?.productName : data?.clickedProduct?.genericName,
        type: data.type == "diseases" ? "Diseases" : data.type == "manufacturer" ? "Manufacturer" : data.type
      })}`;
    } else {
      url = `/search/query?${generateEncodedUrl({
        search: data.type === "Manufacturer" ? data.name : data.id,
        searchQuery: searchQuery || "",
        // term: searchQuery,
        term: data.type === "Diseases" || data.type === "Psychiatry and Psychology" ? data.term : data.type === "Manufacturer" ? data.name : data?.openfda?.brand_name ? data?.openfda?.brand_name : data?.openfda?.generic_name,
        type: data.type
      })}`;
    }
    setIsClickLoading(true);
    router.push(url);
  };
  const [isClickLoading, setIsClickLoading] = useState(false);
  const [letterLoading, setLetterLoading] = useState(false);
  const [searchButtonLoading, setSearchButtonLoading] = useState(false);

  // Handle navigation events to control loader visibility
  useEffect(() => {
    // Create event listeners for router events
    const handleRouteChangeStart = () => {
      setIsClickLoading(true);
    };
    const handleRouteChangeComplete = () => {
      setIsClickLoading(false);
      setLetterLoading(false);
      setSearchButtonLoading(false);
    };

    // Add event listeners for page transitions
    window.addEventListener('beforeunload', handleRouteChangeStart);

    // Clean up event listeners
    return () => {
      window.removeEventListener('beforeunload', handleRouteChangeStart);
    };
  }, []);

  // Reset loading state when component mounts (in case of back navigation)
  useEffect(() => {
    setIsClickLoading(false);
    setLetterLoading(false);
    setSearchButtonLoading(false);
  }, [pathname]);
  return <>

      {isClickLoading && <Loader />}
      {showSearchComponent && <div className="  w-full">
          <div className="flex flex-col  overflow-auto w-full">
            <div className=" flex-1   bg-white rounded-lg">
              <div className="search-background flex justify-center items-center flex-col h-full rounded-lg flex-1">
                <div className="flex justify-center pt-8 sm:pt-12 items-center w-full text-lg sm:text-xl md:text-[24px] font-semibold text-black font-poppins px-4 text-center">
                  Search in Alpha.MD
                </div>
                <form onSubmit={e_0 => {
              e_0.preventDefault();
              // debouncedSearch(searchQuery)

              if (searchQuery) {
                void logKeywordSearch(searchQuery);
                setSearchButtonLoading(true);
                setIsClickLoading(true);
                router.push(`/search/query?${generateEncodedUrl({
                  searchQuery: searchQuery,
                  term: searchQuery,
                  type: "general"
                })}`);
              }
            }} className="flex flex-col sm:flex-row relative gap-3 sm:gap-4 items-stretch sm:items-center justify-center w-full pb-12 sm:pb-20 px-4 pt-6 sm:pt-10">
                  <div className="border flex-1 border-[#EEEEEE] bg-white flex items-center p-2.5 sm:p-3 gap-2 sm:gap-3 rounded-lg">
                    <div className="flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <path d="M13.855 13.145L10.605 9.89499H10.57C11.5718 8.71386 12.078 7.19113 11.9828 5.64534C11.8876 4.09955 11.1984 2.65043 10.0593 1.60113C8.92025 0.551824 7.41955 -0.0163847 5.87115 0.0153612C4.32276 0.0471071 2.84661 0.676349 1.7515 1.77146C0.656391 2.86657 0.0271486 4.34272 -0.00459732 5.89111C-0.0363432 7.43951 0.531866 8.9402 1.58117 10.0793C2.63048 11.2184 4.07959 11.9076 5.62538 12.0028C7.17118 12.0979 8.6939 11.5917 9.87503 10.59C9.87503 10.59 9.87503 10.615 9.87503 10.625L13.125 13.875C13.1715 13.9219 13.2268 13.959 13.2877 13.9844C13.3487 14.0098 13.414 14.0229 13.48 14.0229C13.546 14.0229 13.6114 14.0098 13.6723 13.9844C13.7332 13.959 13.7885 13.9219 13.835 13.875C13.8863 13.8296 13.9277 13.7742 13.9566 13.7121C13.9856 13.6501 14.0015 13.5828 14.0034 13.5143C14.0053 13.4459 13.9931 13.3778 13.9675 13.3143C13.942 13.2507 13.9037 13.1931 13.855 13.145ZM6.00003 11C5.01112 11 4.04442 10.7067 3.22218 10.1573C2.39993 9.60793 1.75907 8.82703 1.38063 7.9134C1.00219 6.99977 0.903175 5.99444 1.0961 5.02453C1.28903 4.05463 1.76523 3.16371 2.46449 2.46445C3.16376 1.76519 4.05467 1.28899 5.02458 1.09606C5.99448 0.903134 6.99981 1.00215 7.91345 1.38059C8.82708 1.75903 9.60797 2.39989 10.1574 3.22213C10.7068 4.04438 11 5.01108 11 5.99999C11 6.6566 10.8707 7.30678 10.6194 7.9134C10.3682 8.52003 9.99986 9.07123 9.53556 9.53552C9.07127 9.99981 8.52007 10.3681 7.91345 10.6194C7.30682 10.8707 6.65664 11 6.00003 11Z" fill="#4B4B4B" />
                      </svg>
                    </div>
                    <input type="text" ref={inputRef} value={searchQuery} onChange={handleSearchChange} onFocus={() => {
                  setIsSuggestionOpen(true);
                }}
                // onBlur={() => {
                //   setIsSuggestionOpen(false);
                // }}
                placeholder="Search for medications, devices, symptoms & more..." className="border-none rounded-lg outline-none w-full text-sm sm:text-[16px] font-normal font-poppins" />
                  </div>



                  <button type="submit" className="bg-[#354EF0] w-full sm:w-auto px-8 sm:px-12 py-2.5 sm:py-3 rounded-lg text-white text-sm sm:text-[16px] font-normal font-poppins">
                    Search
                  </button>
                  {isSuggestionOpen && <div ref={dropdownRef} className="absolute top-[110px] sm:top-[85px] w-[98%] notification-scrollbar left-1/2 transform -translate-x-1/2 mt-2 p-1.5 sm:p-2 bg-white shadow-md rounded-lg max-h-52 sm:max-h-64 overflow-y-auto border border-gray-200 z-50">
                      <ul>
                        {termStatus === "pending" ?
                  // Skeleton loading items
                  Array.from({
                    length: 5
                  }).map((_, index) => <li key={`skeleton-${index}`} className="px-2 sm:px-3 py-1.5 sm:py-2 animate-pulse">
                              <div className="flex items-center space-x-2 sm:space-x-3">
                                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gray-200 rounded-full flex-shrink-0"></div>
                                <div className="flex-1 space-y-1.5 sm:space-y-2 min-w-0">
                                  <div className="h-3 sm:h-4 bg-gray-200 rounded w-3/4"></div>
                                  <div className="h-2.5 sm:h-3 bg-gray-200 rounded w-1/2"></div>
                                </div>
                              </div>
                            </li>) : (/* Combine searchHistory and termList */
                  (() => {
                    // Match exact families and selected records without
                    // hiding products that only share a displayed brand.
                    const displayedHistory = uniqueSearchSuggestions(searchHistory.filter(search => {
                      return search.clickedProduct?.productId && getSearchSuggestionLabel(search, "history").toLowerCase().includes(searchQuery.toLowerCase());
                    }).map(search_0 => withSearchSuggestionHistoryDisplay(search_0, termList)), "history");
                    const displayedHistoryKeys = new Set(displayedHistory.flatMap(search_1 => getSearchSuggestionIdentities(search_1, "history")));
                    const historyItems = displayedHistory.map((search_2, index_0) => {
                      return <SearchHistoryItem clickLoading={setIsClickLoading} handleClick={handleClick} key={`SEARCH_HISTORY_${index_0}`} search={search_2} type={"history"} />;
                    });

                    // Render termList items with the search icon
                    const termItems = uniqueSearchSuggestions(termList).filter(item_0 => {
                      return !getSearchSuggestionIdentities(item_0).some(identity => displayedHistoryKeys.has(identity));
                    }).map((item_1, index_1) => <SearchHistoryItem clickLoading={setIsClickLoading} handleClick={handleClick} key={`SEARCH_HISTORY_${index_1}`} search={item_1} type={"search"} />);

                    // Combine and render both lists
                    return <>
                                  {historyItems}
                                  {termItems}
                                </>;
                  })())}
                        {!isExactMatch(searchQuery) && searchQuery && <div onClick={() => {
                    void logKeywordSearch(searchQuery);
                    router.push(`/search/query?${generateEncodedUrl({
                      searchQuery: searchQuery,
                      term: searchQuery,
                      type: "general"
                    })}`);
                  }} className="flex items-center justify-between px-2 sm:px-3 py-1.5 sm:py-2 cursor-pointer text-sm sm:text-base hover:bg-gray-100 rounded">
                          <span className="truncate mr-2">{`Search for "${searchQuery}"`}</span>
                          <IoArrowForward className="flex-shrink-0" />
                        </div>}
                        {/* Fallback message when there are no results */}
                        {searchHistory.length === 0 && termList.length === 0 && <p className="text-sm sm:text-base px-2 py-1">No results found!</p>}
                      </ul>


                    </div>}
                </form>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row items-stretch browse-container gap-4 sm:gap-6 w-full mt-4 sm:mt-6 px-4 sm:px-0">
              <div className="flex-1 h-full bg-white browse-by-letter rounded-lg p-4 sm:p-6">
                <h2 className="text-sm sm:text-[16px] font-semibold mb-3 sm:mb-4">
                  Browse by letter, A-Z
                </h2>
                <div className="border-b border-[#E1E1E1] mb-3 sm:mb-4"></div>
                <div className="grid grid-cols-6 xs:grid-cols-8 sm:grid-cols-9 md:grid-cols-12 gap-1.5 sm:gap-2">
                  {letters.map(letter_0 => <Link key={letter_0} href={`/products/alphabetical/${letter_0}`} prefetch={false} onClick={e_1 => {
                e_1.preventDefault();
                setLetterLoading(true);
                setIsClickLoading(true);
                router.push(`/products/alphabetical/${letter_0}`);
              }} className={`w-full p-1.5 sm:p-2 text-center text-base sm:text-lg md:text-[20px] font-semibold rounded-md ${selectedLetter === letter_0 ? "bg-[#1E5EFF] text-white" : "bg-[#F5F5F5] text-gray-800 hover:bg-gray-200"}`}>
                      {letter_0}
                    </Link>)}
                </div>
              </div>
              <div className="hidden p-4 sm:p-6 bg-white w-full lg:w-[39%] rounded-lg browse-by-letter shadow-sm">
                <h2 className="text-sm sm:text-[16px] font-semibold mb-3 sm:mb-4">
                  Browse by category
                </h2>
                <div className="border-b border-[#E1E1E1] mb-3 sm:mb-4"></div>
                <ul className="space-y-2">
                  {categories.map(category => <li key={category.value} className="flex items-center">
                      <span className="w-2 h-2 bg-[#354EF0] rounded-full mr-3"></span>
                      <div className="text-[#354EF0] cursor-pointer text-sm sm:text-[16px] font-normal font-inter hover:underline">
                        {category.title}
                      </div>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>}

    </>;
};
export default Search;